"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_dashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "dashboard-mid"), /*#__PURE__*/React.createElement("g", {
    id: "5c05c062-3fd3-475b-b753-a48a7bb14300",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46cef892-93bc-4c86-9aa6-e61473d1c662",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    id: "c84179fe-932b-41ee-9df9-6982ccfa0946",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 38,
    x2: 96,
    y2: 50,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "c0e5da49-edc9-4ed5-8dc4-3fe44f8d320a",
    "data-name": "<Pfad>",
    d: "M137,55,102.76,89.18a10.18,10.18,0,1,0,0,14.39",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "572b52a4-24b0-4b14-80d7-0e7e78dac291",
    "data-name": "<Pfad>",
    x1: 54.99,
    y1: 54.99,
    x2: 63.47,
    y2: 63.47,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "a1244b4b-9cee-4117-bf7c-5ab67cc6833b",
    "data-name": "<Pfad>",
    x1: 38.06,
    y1: 96,
    x2: 50,
    y2: 96,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "31e0c1ff-8185-46b3-8111-751f93676f9b",
    "data-name": "<Pfad>",
    x1: 142,
    y1: 96,
    x2: 154,
    y2: 96,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 78,
    fill: "none",
    stroke: "#6e6a69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_dashboard;
exports.default = _default;